<template>
	<div>
		<!-- Preview mode -->
		<div class="xs-12 bg5">
			<!-- Paragraphs -->
			<div v-for="paragraph in paragraphs" :key="paragraph.id" class="p2">
				<!-- name -->
				<div class="fs6 fw7 p2">{{ paragraph.name }}</div>
				<!-- items -->
				<div class="xs-12 p2" v-for="(item, i) in paragraph.items" :key="i">
					<div v-if="item.type === 'HEADLINE'" class="fw5 fs5 lh150 pt2">
						{{ item.localizedContent }}
					</div>
					<div v-if="item.type === 'TEXT'" class="fs4 lh125">
						{{ item.localizedContent }}
					</div>
					<div v-if="item.type === 'LIST'" class="pl6">
						<div
							v-for="(listItem, i) in item.options"
							:key="i"
							class="lh125 mb2"
						>
							{{ listItem.localizedContent }}
						</div>
					</div>
					<div v-if="item.type === 'HTML'" v-html="item.localizedContent"></div>
					<div
						v-if="item.type === 'IMAGE' && item.localizedContent"
						class="xs-12"
					>
						<page-preview-image :filekey="item.localizedContent" />
					</div>

					<div v-if="item.type === 'VIDEO' && item.localizedContent">
						<page-preview-video :filekey="item.localizedContent" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PagePreviewImage from "./PagePreviewImage"
import PagePreviewVideo from "./PagePreviewVideo"

export default {
	props: {
		page: Object,
		resourceId: String
	},
	computed: {
		paragraphs() {
			return this.page?.lessons || []
		}
	},
	components: {
		PagePreviewImage,
		PagePreviewVideo
	}
}
</script>
